export default __webpack_public_path__ + "static/media/nhatpha.ba81eaab.png";